import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider, createTheme  } from '@material-ui/core/styles';
import Login from '../Login';
import Logout from '../Logout';
import SignUp from '../SignUp';
// import KlaraMeasssage from '../KlaraWidget';
import DependentPatientSignUpModal from '../SignUp/DependentPatientSignUpModal';
import DependentSignUpConformation from '../SignUpConfirmation/DependentSignUpConformation';
import AffiliateHomePage from '../AffiliateHomePage';
import SignUpConfirmation from '../SignUpConfirmation';
import ForgotPassword from '../ForgotPassword';
import ForgotPasswordConfirmation from '../ForgotPasswordConfirmation';
import PasswordReset from '../PasswordReset';
import PasswordResetConfirmation from '../PasswordResetConfirmation';
import AppointmentCancel from '../AppointmentCancel';
import AppointmentCancelConfirmation from '../AppointmentCancelConfirmation';
import PatientAdmin from '../PatientAdmin';
import PatientConsultNotes from '../../components/PatientConsultNotes';
import Search from '../Search';
import SearchCheckout from '../SearchCheckout';
import SearchConfirmation from '../SearchConfirmation';
import Activate from '../Activate';
import ConsultNote from '../ConsultNote';
import ProviderProfileMain from '../ProviderProfile/ProviderProfileMain';
import ProviderAdmin from '../ProviderAdmin';
import PublicNavigation from '../../components/PublicNavigation';
import LogoHeader from '../../components/LogoHeader';
import PublicFooter from '../../components/PublicFooter';
import { CurrentUserProvider } from '../../contexts/CurrentUserContext';
import {
  AppointmentProvider,
  AppointmentConsumer,
} from '../../contexts/AppointmentContext';
import {
  CurrentPatientProvider,
  CurrentPatientConsumer,
} from '../../contexts/CurrentPatientContext';
import { getPatientAllMessages } from '../../services/api/index';
import * as api from '../../services/api/auth';
import { FilterSearchProvider } from '../../contexts/FilterContext';

const theme = createTheme ({
  typography: {
    useNextVariants: true,
    h6: {
      color: '#616161',
    },
  },
  palette: {
    primary: {
      main: '#505D68',
      light: '#879bad',
      dark: '#25303a',
    },
  },
  overrides: {
    MuiButton: {
      text: {
        color: 'white',
      },
    },
    MuiDialog: {
      root: {
        marginTop: '100px',
      },
    },
    MuiAppBar: {
      root: {
        zIndex: '999',
      },
    },
  },
});

class Root extends Component {
  state = {
    currentUser: {},
    currentPatientInfo: [],
    parentCount: 0,
    childCount: 0,
    commonCount: 0,
  };

  // async componentDidMount() {
  //   this.getCommonCount();
  // }
    async componentDidMount() {
      window.pageview(window.location.pathname+window.location.search);
  }
 
  async componentDidMount() {
    this.attemptToFetchCurrentUser();
    this.getCommonCount();
  }

  attemptToFetchCurrentUser = async () => {
    try {
      const currentUser = await api.fetchCurrentUser();
      this.setState({ currentUser });
      if (
        currentUser &&
        currentUser.patient &&
        currentUser.patient.id !== undefined
      ) {
        const currentPatientInfo = await getPatientAllMessages(
          currentUser.patient.id
        );
        this.setState({ currentPatientInfo });
      }
    } catch {
      // no-op; not being logged in is not an error state
    }
  };

  /**
   * get Total count for patient messages
   */
  getCommonCount = async () => {
    const currentUser = await api.fetchCurrentUser();
    this.setState({ currentUser });
    let currentPatientInfo;
    if (
      currentUser &&
      currentUser.patient &&
      currentUser.patient.id !== undefined
    ) {
      currentPatientInfo = await getPatientAllMessages(currentUser.patient.id);
      this.setState({ currentPatientInfo });
    }
    let counts = currentPatientInfo?.reduce(
      (acc, curr) => acc + curr.messageCount,
      0
    );
    this.setState({ commonCount: counts });
  };

  /**
   * Logout function
   */
  onLogout = async () => {
    try {
      await api.logoutUser();
      sessionStorage.removeItem('redirect1');
      sessionStorage.removeItem('redirect2');
      localStorage.removeItem('pathRedirect');
      localStorage.removeItem('pathUrl');
      localStorage.removeItem('info');
    } finally {
      window.location.href = process.env.REACT_APP_HOMEPAGE_URL || '\\';
    }
  };

  render() {
    const { currentUser, currentPatientInfo } = this.state;
    const { classes } = this.props;
    return (
      <CurrentUserProvider value={currentUser}>
        <CurrentPatientProvider value={currentPatientInfo}>
          <AppointmentProvider>
            <FilterSearchProvider>
            <ThemeProvider theme={theme}>
              <SnackbarProvider maxSnack={3}>
                <Router>
                  <Switch>
                    <Route
                      path="/"
                      exact
                      render={() => <Redirect  to={'/login'} />}
                    />

                    <Route
                      path="/login"
                      render={({ match: { url } }) => (
                        <div className={classes.footerContainer}>
                          <PublicNavigation
                            onLogout={this.onLogout}
                            attemptToFetchCurrentUser={
                              this.attemptToFetchCurrentUser
                            }
                            getCommonCount={()=>this.getCommonCount()}
                          />
                          <Route path={url} exact component={Login} />
                          <PublicFooter />
                        </div>
                      )}
                    />

                    <Route
                        path="/logout"
                      render={({ match: { url } }) => (
                        <Route path={url} exact component={Logout} />
                      )}
                      />

                    <Route
                      path="/affiliate"
                      render={({ match: { url } }) => (
                        <>
                          <LogoHeader />
                          <Switch>
                            <Route
                              path={`${url}/sign-up/confirmation/:affiliateId`}
                              render={({ match }) => (
                                <SignUpConfirmation
                                  affiliateId={match.params.affiliateId}
                                />
                              )}
                            />
                            <Route
                              path={`${url}/sign-up/:affiliateId`}
                              render={({ match }) => (
                                <SignUp
                                  affiliateId={match.params.affiliateId}
                                />
                              )}
                            />
                            <Route
                              path={`${url}/:affiliateId`}
                              render={({ match }) => (
                                <AffiliateHomePage
                                  affiliateId={match.params.affiliateId}
                                />
                              )}
                            />
                          </Switch>
                        </>
                      )}
                    />

                    <Route
                      path="/sign-up"
                      render={({ match: { url } }) => (
                        <CurrentPatientConsumer>
                          {value => (
                            <div className={classes.footerContainer}>
                              <PublicNavigation
                                onLogout={this.onLogout}
                                context={currentPatientInfo}
                              />
                              <Switch>
                                <Route exact path={url} component={SignUp} />

                                <Route
                                  exact
                                  path={`${url}/confirmation`}
                                  component={SignUpConfirmation}
                                />

                                <Route
                                  exact
                                  path={`${url}/dependent-patient-conformation`}
                                  component={DependentSignUpConformation}
                                />

                                <Route
                                  exact
                                  path={`${url}/dependent-patient-signup`}
                                  component={DependentPatientSignUpModal}
                                />
                              </Switch>
                              <PublicFooter />
                            </div>
                          )}
                        </CurrentPatientConsumer>
                      )}
                    />

                    <Route
                      path="/password-reset"
                      render={({ match: { url } }) => (
                        <div className={classes.footerContainer}>
                          <PublicNavigation onLogout={this.onLogout} />
                          <Switch>
                            <Route
                              path={url}
                              exact
                              component={ForgotPassword}
                            />
                            <Route
                              path={`${url}/confirmation`}
                              component={ForgotPasswordConfirmation}
                            />

                            <Route
                              path={`${url}/reset/confirmation`}
                              component={PasswordResetConfirmation}
                            />

                            <Route
                              path={`${url}/:reason/:resetToken`}
                              render={({ match }) => (
                                <PasswordReset match={match} />
                              )}
                            />
                          </Switch>
                          <PublicFooter />
                        </div>
                      )}
                    />

                    <Route
                      path="/appointments/cancel"
                      render={({ match: { url } }) => (
                        <div className={classes.footerContainer}>
                          <PublicNavigation onLogout={this.onLogout} />
                          <Switch>
                            <Route
                              path={`${url}/confirmation`}
                              component={AppointmentCancelConfirmation}
                            />
                            <Route
                              path={`${url}/:cancelToken`}
                              component={AppointmentCancel}
                            />
                          </Switch>
                          <PublicFooter />
                        </div>
                      )}
                    />

                    <Route
                      path="/search"
                      render={({ match: { url } }) => (
                        <div className={classes.footerContainer}>
                          <PublicNavigation onLogout={this.onLogout} />
                          <Route path={url} exact component={Search} />
                          <Route
                            path={`${url}/checkout`}
                            render={() => (
                              <AppointmentConsumer>
                                {value => <SearchCheckout context={value} />}
                              </AppointmentConsumer>
                            )}
                          />
                          <Route
                            path={`${url}/confirmation`}
                            render={() => (
                              <AppointmentConsumer>
                                {value => (
                                  <SearchConfirmation
                                    context={value}
                                    currentUser={currentUser}
                                  />
                                )}
                              </AppointmentConsumer>
                            )}
                          />

                          <Route
                            path={`${url}/apt-request-confirmation`}
                            render={() => (
                              <AppointmentConsumer>
                                {value => (
                                  <SearchConfirmation
                                    context={value}
                                    currentUser={currentUser}
                                    isAptRequest
                                  />
                                )}
                              </AppointmentConsumer>
                            )}
                          />

                          <PublicFooter />
                        </div>
                      )}
                    />

                    <Route
                      path="/patients"
                      render={({ match: { url } }) => (
                        <CurrentPatientConsumer>
                          {value => (
                            <>
                              <PublicNavigation
                                onLogout={this.onLogout}
                                context={currentPatientInfo}
                                attemptToFetchCurrentUser={
                                  this.attemptToFetchCurrentUser
                                }
                                commonCount={this.state.commonCount}
                                getCommonCount={() => this.getCommonCount()}
                              />
                              <Route
                                path={`${url}`}
                                exact
                                component={PatientAdmin}
                              />
                              {/* <KlaraMeasssage /> */}
                            </>
                          )}
                        </CurrentPatientConsumer>
                      )}
                    />

                    <Route
                      path="/patientConsultNotes"
                      render={({ match: { url } }) => (
                        <CurrentPatientConsumer>
                          {value => (
                            <>
                              <PublicNavigation
                                onLogout={this.onLogout}
                                context={currentPatientInfo}
                                attemptToFetchCurrentUser={
                                  this.attemptToFetchCurrentUser
                                }
                                commonCount={this.state.commonCount}
                                getCommonCount={() => this.getCommonCount()}
                              />

                              <Route
                                path={`${url}`}
                                exact
                                component={
                                  <PatientConsultNotes
                                    context={value}
                                    currentUser={currentUser}
                                    attemptToFetchCurrentUser={this.attemptToFetchCurrentUser}
                                    getCommonCount={() => this.getCommonCount()}
                                  />
                                }
                              />
                              {/* <KlaraMeasssage /> */}
                            </>
                          )}
                        </CurrentPatientConsumer>
                      )}
                    />

                    <Route
                      path="/activate"
                      render={({ match: { url } }) => (
                        <div className={classes.footerContainer}>
                          <PublicNavigation onLogout={this.onLogout} />
                          <Route path={`${url}`} exact component={Activate} />
                          <PublicFooter />
                        </div>
                      )}
                    />

                    <Route
                      path="/consult-notes"
                      render={({ match: { url } }) => (
                        <>
                          <PublicNavigation onLogout={this.onLogout} />
                          <Route
                            path={`${url}/:token`}
                            exact
                            component={ConsultNote}
                          />
                          <PublicFooter />
                        </>
                      )}
                    />

                    <Route
                      path="/provider-profile"
                      render={({ match: { url } }) => (
                        <div className={classes.footerContainer}>
                          <PublicNavigation onLogout={this.onLogout} />
                          <Route
                            path={`${url}/:token`}
                            exact
                            component={ProviderProfileMain}
                          />
                          <PublicFooter />
                        </div>
                      )}
                    />

                    <Route
                      path="/admin"
                      render={({ match: { url } }) => (
                        <Route path={url} component={ProviderAdmin} />
                      )}
                    />
                  </Switch>
                </Router>
              </SnackbarProvider>
            </ThemeProvider>
            </FilterSearchProvider>
          </AppointmentProvider>
        </CurrentPatientProvider>
      </CurrentUserProvider>
    );
  }
}

const styles = () => ({
  footerContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
});

export default withStyles(styles)(Root);
